import { useQuery } from "@tanstack/react-query";
import { SailModelsType } from "@/types/apiTypes";
import { fetchSailModelsApi } from "@/API/fetchSailModelsApi";
import { useLoadingContext } from "@/hooks/contextHooks/useLoadingContext";

export const useFetchSailModels = () => {
  const { startLoading, stopLoading } = useLoadingContext();

  const query = useQuery<SailModelsType[], Error>({
    queryKey: ["sailModels"],
    queryFn: async () => {
      startLoading();

      try {
        return await fetchSailModelsApi();
      } finally {
        console.log("✅ Request completed.");
        stopLoading();
      }
    },
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });

  if (query.isFetching) {
    console.log("❌ Request overridden for sail models.");
  }

  return query;
};
